// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__yXEQt","label":"style_label__ss800","textArea":"style_textArea__1o0l5"};